module.exports = __webpack_public_path__ + "static/box-4ae2d1f49c0e7bef52fda349914607e2.png";